<p-drawer
  #drawerRefLeft
  [(visible)]="isVisibleLeft"
  [position]="'left'"
  [modal]="true"
  [closeOnEscape]="false"
  [dismissible]="false"
  (onHide)="isVisibleLeft = false"
  (onShow)="addStyles('left')"
  (onHide)="resetStyles('left'); auxiliarService.closeDrawer('left');"
>
  <ng-template pTemplate="header">
    <span class="p-drawer-title">
      <i [class]="iconLeft" *ngIf="iconLeft"></i>
      {{ titleLeft }}
    </span>
  </ng-template>
  <ng-container #dynamicComponentContainerLeft></ng-container>
</p-drawer>

<p-drawer
  #drawerRefRight
  [(visible)]="isVisibleRight"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="false"
  [dismissible]="false"
  (onHide)="isVisibleRight = false"
  (onShow)="addStyles('right')"
  (onHide)="resetStyles('right'); auxiliarService.closeDrawer('right');"
>
  <ng-template pTemplate="header">
    <span class="p-drawer-title">
      <i [class]="iconRight" *ngIf="iconRight"></i>
      <i [class]="iconRightRight" [pTooltip]="iconRightRightTooltip"
        tooltipEvent="hover" tooltipPosition="bottom" *ngIf="iconRightRight"></i>
      {{ titleRight }}
    </span>
  </ng-template>
  <ng-container #dynamicComponentContainerRight></ng-container>
</p-drawer>